import onlineBookingTypes from './booking.types';

export const initialState = {
  bookings: [],
  singlePatientBookingsDetails: {}
};

export const onlineBookingsReducers = (state = initialState, action) => {
  switch (action.type) {
    case onlineBookingTypes.GET_ALL_ONLINE_BOOKING:
      return {
        ...state,
        bookings: action.payload
      };
    case onlineBookingTypes.SAVE_VISIT_FROM_BOOKING:
      return {
        ...state,
        singlePatientBookingsDetails: action.payload
      };

    default:
      return state;
  }
};

export default onlineBookingsReducers;
